module.exports = __webpack_public_path__ + "media/bootstrap-icons/mic-mute-11003614.svg";